import slugify from 'slugify'
import _ from 'underscore'
import Vue from 'vue'

export default {

	stringAsNumber: function(text) {

		var value = '1'
		var alphabet = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']

		for (var i = 1; i <= 10; i++) {

			if (text.length >= i) {

				if (_.contains(alphabet, text[i - 1].toLowerCase())) {

					value += alphabet.indexOf(text[i - 1].toLowerCase()).toString().padStart(2, '0')

				}  else {

					value += '00'

				}

			} else {

				value += '00'

			}

		}

		return parseInt(value)

	},
	
	clone: function(a) {

		return JSON.parse(JSON.stringify(a))

	},

	generateKey: function(length, characters) {

		length = length || 8
		var result = ''
		characters = characters || 'abcdefghijklmnopqrstuvwxyz0123456789'
		var charactersLength = characters.length

		for ( var i = 0; i < length; i++ ) {
			result += characters.charAt(Math.floor(Math.random() * charactersLength))
		}

		return result

	},

	search: function(text, match) {

		text = slugify(text, {
			replacement: ' ',
			lower: true,
			remove: /[*+~.()'"!:@]/g,
			strict: true
		})

		match = slugify(match, {
			replacement: ' ',
			lower: true,
			remove: /[*+~.()'"!:@]/g,
			strict: true
		})

		return text.indexOf(match) >= 0

	},

	collection: {
	
		$find: function(collection, value) {

			var id = (typeof value === 'object') ? value.id : value

			var index = _.findIndex(collection, {
				id: id
			})

			return (index === -1) ? false : index

		},

		get: function(collection, value) {

			return collection[this.$find(collection, value)]

		},

		add: function(collection, value, insert) {

			insert = (insert === undefined) ? false : insert

			if (!this.$find(collection, value)) {
				
				if (insert === false) {

					collection.push(value)

				} else {

					collection.splice(insert, 0, value)

				}

			}

		},

		remove: function(collection, value) {

			var index = this.$find(collection, value)

			if (index !== false) collection.splice(index, 1)

			return index

		},

		up: function(collection, value) {

			var index = this.$find(collection, value)

			if (index !== false) {

				var other = collection[index - 1]
				Vue.set(collection, index - 1, collection[index])
				Vue.set(collection, index, other)

			}

			return index

		},

		down: function(collection, value) {

			var index = this.$find(collection, value)

			if (index !== false) {

				var other = collection[index + 1]
				Vue.set(collection, index + 1, collection[index])
				Vue.set(collection, index, other)

			}

			return index

		},

		update: function(collection, data) {

			var index = this.$find(collection, data)

			if (index !== false) Vue.set(collection, index, data)

			return index

		}

	}

}